// extracted by mini-css-extract-plugin
export var chevron = "_lj-2";
export var chevronRotated = "_lj-3";
export var header = "_lj-1";
export var section = "_lj-0";